import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { PaymentsService } from 'src/app/services/core/payments/payments.service';
import { NUMBER_OF_RECORDS} from 'src/app/utils/common.utils';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  styleUrls: ['./payments-list.component.css']
})
export class PaymentsListComponent implements OnInit {
  payments: any = [];
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any;
  timeZone:any = timeZone;
  status = true;
  // todayDate:any = [];
  userPermission=UserPermission
  private readonly searchSubject = new Subject<string | undefined>();

  constructor(
     private route: ActivatedRoute,
     private paymentsService: PaymentsService,
     public permissionService: PermissionService
  ) { }

  ngOnInit() {
  //  this.todayDate = [
  //             moment().tz(this.timeZone).startOf("day"),
  //             moment().tz(this.timeZone).endOf("day"),
  //           ];
    this.getPayments(this.currentPage);
    this.listenSearch();
    
  }

  getPayments(page: number) {
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      // time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      isActive: this.status,
      sortBy: 'isDefault:desc,createdAt:desc'
    }

    if (this.search) {
      queryparams['search'] = this.search;
    }
    this.paymentsService
      .getPaymentMethods(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.payments = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });


  }


  onPageChange(page: number) {
    this.currentPage = page;
    this.getPayments(page);
  }

  onSearch(query: any) {
    if (query) {
      this.searchSubject.next(query);
    } else {
      this.currentPage = 1;
      this.getPayments(this.currentPage);
    }
  }
//  onDateChange(event: any) {
//     this.todayDate = [
//       event[0],
//       event[1].endOf("day"),
//     ];
//      this.currentPage = 1;
//     this.getPayments(this.currentPage);
//   }
  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.currentPage = 1;
        this.payments = [];
        this.getPayments(this.currentPage);
      });
  }

  async deletePayment(id: any) {
    const result = await sweetAlert(
      "Alert",
      `Are you sure you want to delete this payment method?`,
      "warning",
      "Yes",
      "No"
    );
    if (!result.value) return;
    this.paymentsService.deletePaymentMethod(id).subscribe((data: any) => {
      this.getPayments(this.currentPage);
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    });
  }
}